import React, { Component } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

class MeetingAndTrainingGroupGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
            {
                field: 'id',
                headerName: "ID",
                cellClass: 'non-number',
                width: 80,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true
            },
            {
                field: 'groupname',
                headerName: "GroupName*",
                cellClass: 'non-number',
                width: 300,
            },
            {
                field: 'accountname',
                headerName: "Name*",
                cellClass: 'non-number',
                width: 320,
            },
            {
                field: 'createdby',
                headerName: "Created By",
                cellClass: 'number',
                width: 100,
            },
            {
                field: 'createddate',
                headerName: "Created Date",
                cellClass: 'number',
                width: 100,
            },
            // {
            //     field: 'filepath',
            //     headerName: "User Access Form",
            //     cellClass: 'non-number',
            //     width: 300,
            //     cellRenderer: this.sendHistoryAttachementCellRender
            // },
        ],
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 50
            },
            rowSelection: "multiple",
            context: { componentParent: this },
            statusBar: {
                statusPanels: [
                  {
                    statusPanel: "agTotalAndFilteredRowCountComponent",
                    align: "left"
                  },
                  {
                    statusPanel: "agTotalRowCountComponent",
                    align: "center"
                  },
                  { statusPanel: "agFilteredRowCountComponent" },
                  { statusPanel: "agSelectedRowCountComponent" },
                  { statusPanel: "agAggregationComponent" }
                ]
            },
        };
    }
    sendHistoryAttachementCellRender = (node) => {
        const attachement = node.data.filepath;
        if(!attachement) {
            return '';
        }
        const attArray = attachement.split(';');
        const retElement = document.createElement('div');
        let first = true;
        attArray.forEach(e => {
            if(!first) {
                retElement.append(' | ');
            }
            first = false;

            const url = this.props.meetingAndTrainingGroupDownloadUrl + '/' + e;
            const link = document.createElement('a');
            link.innerText = e;
            link.target = '_blank';
            link.href = url;
            retElement.appendChild(link);

        });
        return retElement;
    }
    getRowNodeId = data => {
        return data.id;
    };

    onDataSelectionChanged = (event) => {
        let rowNodeArray = event.api.getSelectedNodes();
        let meetingAndTrainingGroupInfoArray = rowNodeArray.map(rowNode => rowNode.data);
        this.props.selectMeetingAndTrainingGroupInfo(meetingAndTrainingGroupInfoArray);
    }

    render() {

        const {
            // query
            loadMeetingAndTrainingGroupInfoActionStatus,
            loadMeetingAndTrainingGroupInfoResp,
        } = this.props;


        const isLoading = loadMeetingAndTrainingGroupInfoActionStatus === ACTION_STATUS.LOGINING;
        let loadMeetingAndTrainingGroupInfoArray = [];
        if(!!loadMeetingAndTrainingGroupInfoResp && !!loadMeetingAndTrainingGroupInfoResp.data) {
            loadMeetingAndTrainingGroupInfoArray = loadMeetingAndTrainingGroupInfoResp.data;
        }


        return (
            <div className={'ag-theme-balham grid-wrapper'}>
                {isLoading ? (
                        <Loader active content="Loading..." />
                    ) : (
                        <AgGridReact
                            // properties
                            columnDefs={this.state.columnDefs}
                            rowData={loadMeetingAndTrainingGroupInfoArray}
                            defaultColDef={this.state.defaultColDef}
                            rowSelection={this.state.rowSelection}
                            suppressRowClickSelection={true}
                            suppressAggFuncInHeader={true}
                            enableSorting={true}
                            enableFilter={true}
                            animateRows={true}
                            deltaRowDataMode={false}
                            enableColResize={true}
                            enableRangeSelection={true}
                            getRowNodeId={this.getRowNodeId}
                            context={this.state.context}
                            statusBar={this.state.statusBar}
                            // event
                            onSelectionChanged={this.onDataSelectionChanged}
                        />
                    )}
            </div>
        );
    }
}

export default MeetingAndTrainingGroupGrid;
